import React, { Fragment, useEffect, useState } from 'react'
import Control from 'components/Control/Control'
import Button from 'components/Button'
import FileReader from 'components/Uploader/FileReader'
import Uploadloader from 'components/Uploader/Uploader'
import {
  Heading,
  SubHeading,
  RadioGroup,
} from 'modules/Onboarding/Register/ProofDocuments/style'
import RadioButton from 'components/Form/RadioButton'
import { Form } from 'antd'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import Label from 'components/Label/Label'
import { FormItem } from 'modules/Onboarding/Register/PersonalInfo/style'

const ProofDocuments = ({
  setCurrent,
  studentData,
  studentFormData,
  updateStudentData,
  activeKey,
}) => {
  const [form] = Form.useForm()
  const [idProofFile, setIdProofFile] = useState(null)
  const [addressProofFile, setAddressProofFile] = useState(null)
  const [idProof, setIdProof] = useState(
    studentFormData?.studentPersonalProfile?.idProof[0]?.document ||
      'driving_licence'
  )
  const [addressProof, setAddressProof] = useState(
    studentFormData?.studentPersonalProfile?.addressProof[0]?.document ||
      'pan_card'
  )
  const [aadharProofFront, setAadharProofFront] = useState(null)
  const [aadharProofBack, setAadharProofBack] = useState(null)

  useEffect(() => {
    let idProofData = studentFormData?.studentPersonalProfile?.idProof
    let addressProofData = studentFormData?.studentPersonalProfile?.addressProof

    setIdProof(idProofData[0]?.document || 'driving_licence')
    setAddressProof(addressProofData[0]?.document || 'pan_card')

    const getAadharData = list => {
      list[0]?.name?.includes('front') && setAadharProofFront(list[0])
      list[1]?.name?.includes('back') && setAadharProofBack(list[1])
    }

    if (idProofData[0]?.document === 'aadhaar_card') {
      getAadharData(idProofData)
    } else {
      setIdProofFile(idProofData[0])
    }

    if (addressProofData[0]?.document === 'aadhaar_card') {
      getAadharData(addressProofData)
    } else {
      setAddressProofFile(addressProofData[0])
    }
  }, [studentFormData])

  useEffect(() => {
    const getObject = (document, file) => {
      if (document === 'aadhaar_card') {
        return {
          document: document,
          aadhar_front_url: aadharProofFront?.url,
          aadhar_back_url: aadharProofBack?.url,
        }
      } else {
        return {
          document: document,
          url: file?.url,
        }
      }
    }

    form.setFieldsValue({
      idProof: getObject(idProof, idProofFile),
      addressProof: getObject(addressProof, addressProofFile),
    })
  }, [idProofFile, addressProofFile, addressProof, idProof])

  const onChangeIdProof = value => {
    setIdProof(value?.target?.value)
    setIdProofFile(null)
    if (addressProof !== 'aadhaar_card') {
      setAadharProofFront(null)
      setAadharProofBack(null)
    }
  }

  const onChangeAddressProof = value => {
    setAddressProof(value?.target?.value)
    setAddressProofFile(null)
    if (idProof !== 'aadhaar_card') {
      setAadharProofFront(null)
      setAadharProofBack(null)
    }
  }

  const getUploader = (formName, feildName, file, setFile, fileNmae) => {
    return (
      <FormItem name={[[formName], [feildName]]}>
        {file ? (
          <Control column top="20px" center>
            <FileReader file={file} setFile={setFile} />
          </Control>
        ) : (
          <Control column top="20px" center>
            <Uploadloader
              setFile={setFile}
              isDefault={true}
              fileName={fileNmae}
            />
          </Control>
        )}
      </FormItem>
    )
  }

  const getAdharUploader = (formName, fileName) => {
    return (
      <Fragment>
        <Label marginBottom={'0px'} marginTop={'14px'}>
          Front
        </Label>
        {getUploader(
          formName,
          'aadhar_front_url',
          aadharProofFront,
          setAadharProofFront,
          fileName + '_front'
        )}

        <Label marginBottom={'0px'} marginTop={'14px'}>
          Back
        </Label>
        {getUploader(
          formName,
          'aadhar_back_url',
          aadharProofBack,
          setAadharProofBack,
          fileName + '_back'
        )}
      </Fragment>
    )
  }

  const submitHandler = async values => {
    let idProofList = []
    let addressPoofList = []

    if (idProof === 'aadhaar_card') {
      if (aadharProofFront != undefined)
        idProofList.push({ ...aadharProofFront, document: idProof })
      if (aadharProofBack != undefined)
        idProofList.push({ ...aadharProofBack, document: idProof })
    } else if (idProofFile != undefined)
        idProofList.push({ ...idProofFile, document: idProof })
    

    if (addressProof === 'aadhaar_card') {
      if (aadharProofFront != undefined)
        addressPoofList.push({ ...aadharProofFront, document: addressProof })
      if (aadharProofBack != undefined)
        addressPoofList.push({ ...aadharProofBack, document: addressProof })
    } else if (addressProofFile != undefined)
        addressPoofList.push({ ...addressProofFile, document: addressProof })
    

    let payload = {
      admin: {
        ...studentFormData?.admin,
        countryCode: studentFormData?.admin?.countryCode,
      },
      student: studentFormData?.student,
      studentPersonalProfile: {
        ...studentFormData?.studentPersonalProfile,
        idProof: idProofList,
        addressProof: addressPoofList,
      },
      currentCourse: !studentFormData?.student?.isExpCandidate
        ? studentFormData?.currentCourse
        : {},
      education: studentFormData?.education,
      resume: {
        ...studentFormData?.resume,
      },
      degreeStreamMap: !studentFormData?.student?.isExpCandidate
        ? {
            degreeId: studentFormData?.currentCourse?.degreeId,
            streamId: studentFormData?.currentCourse?.streamId,
          }
        : {},
      checkForApproval: true,
    }
    if (payload?.currentCourse?.specialisationId === null) {
      delete payload?.currentCourse?.specialisationId
    }
    if (payload?.studentPersonalProfile?.secondaryEmail === null) {
      delete payload?.studentPersonalProfile?.secondaryEmail
    }
    if (payload?.currentCourse?.degreeStreamMapId === null) {
      delete payload?.currentCourse?.degreeStreamMapId
    }

    studentFormData?.education.map((item, index) => {
      if (item?.skills === null) delete payload?.education[index]?.skills
      if (item?.degreeStreamMapId === null)
        delete payload?.education[index]?.degreeStreamMapId
    })
    let response = await updateStudentData(studentData?.id, payload)
    if (response === true) {
      SuccessMessage('Documents saved successfully!')
      setCurrent(activeKey + 1)
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  return (
    <Fragment>
      <Form
        scrollToFirstError
        onFinish={submitHandler}
        id={'documentForm'}
        form={form}
        layout="vertical"
      >
        <Control flexStart column>
          <Heading>ID Proof</Heading>
          <SubHeading>Choose the file type</SubHeading>
          <FormItem name={['idProof', 'document']}>
            <Control column top="20px">
              <RadioGroup value={idProof} onChange={onChangeIdProof}>
                <RadioButton
                  value={'driving_licence'}
                  label="Driving Licence"
                />
                <RadioButton
                  value={'aadhaar_card'}
                  label="Aadhaar Card"
                  disabled={addressProof === 'aadhaar_card'}
                />
              </RadioGroup>
            </Control>
          </FormItem>

          {idProof !== 'aadhaar_card'
            ? getUploader(
                'idProof',
                'url',
                idProofFile,
                setIdProofFile,
                idProof
              )
            : getAdharUploader('idProof', idProof)}
        </Control>
        <Control flexStart column top="25px">
          <Heading>Address Proof</Heading>
          <SubHeading>Choose the file type</SubHeading>
          <FormItem name={['addressProof', 'document']}>
            <Control column top="20px">
              <RadioGroup value={addressProof} onChange={onChangeAddressProof}>
                <RadioButton value={'pan_card'} label="PAN Card" />
                <RadioButton
                  value={'aadhaar_card'}
                  label="Aadhaar Card"
                  disabled={idProof === 'aadhaar_card'}
                />
                <RadioButton value={'passport'} label="Passport" />
              </RadioGroup>
            </Control>
          </FormItem>
          {addressProof !== 'aadhaar_card'
            ? getUploader(
                'addressProof',
                'url',
                addressProofFile,
                setAddressProofFile,
                addressProof
              )
            : getAdharUploader('addressProof', addressProof)}
        </Control>
      </Form>
      <Control width="100%" flexEnd gap="15px" top="35px">
        <Button.Secondary
          text="Back"
          onClick={() => setCurrent(activeKey - 1)}
        />
        <Button.Primary
          text="Save & Continue"
          htmlType={'submit'}
          form={'documentForm'}
        />
      </Control>
    </Fragment>
  )
}

export default ProofDocuments
